// As SDL no longer initialize tradeUps filter and minicart,
// we need to do it by ourselves.
// Functionality of tradeUps filter and minicart is defimed in apc.js file.

(function() {
    if (tradeFilter) {
        tradeFilter.init();
        tradeFilter.rangeInit();
    }
    if (miniCart) {
        miniCart.init();
    }
})();
